export default __webpack_public_path__ + "static/media/bg05.a039f0b6.jpg";